export default /*@ngInject*/ function ($scope, configurationDataService, RequestManagementOracleCloudService) {

    activate();

    async function activate() {
        await getRoleDescConfigValue();
        await loadDaaEnabledFlag();
    }

    async function getRoleDescConfigValue() {
        let response = await configurationDataService.getProductConfigurationValueByName('orfc', 'IM_ShowRoleDescription');
        $scope.roleDesc = response.data.Value;
    }

    async function loadDaaEnabledFlag() {
        try {
            var response = await configurationDataService.getProductConfigurationValueByName('orfc', 'ORFC_IMEnableDataAccessAssignments');
            $scope.daaEnabled = response?.data?.Value === '1';
        } catch (e) {
            $scope.daaEnabled = false;
        }
    }

    $scope.copyDataAccessAssignments = async function (sourceUser, copiedRoles) {
        if (!copiedRoles || copiedRoles.length === 0) return;
        if (!$scope.vm.OracleCloudDataAccessAssignments) {
            $scope.vm.OracleCloudDataAccessAssignments = [];
        }

        for (var i = 0; i < copiedRoles.length; i++) {
            var role = copiedRoles[i];
            var roleName = role.DisplayName || role.RoleName;

            try {
                var response = await RequestManagementOracleCloudService.getDataAccessAssignments(sourceUser.ID, roleName);
                if (response.data && response.data.length > 0) {
                    response.data.forEach(function (item) {
                        var roleCode = item.RoleCode || item.RoleCommonName || role.RoleName;
                        var securityContext = item.SecurityContextId || item.SecurityContext;
                        var name = item.SecurityContextValue || item.Name;

                        // Dedup: check if assignment already exists
                        var exists = $scope.vm.OracleCloudDataAccessAssignments.some(function (existing) {
                            return existing.RoleCode === roleCode
                                && existing.SecurityContext === securityContext
                                && existing.Name === name;
                        });

                        if (!exists) {
                            $scope.vm.OracleCloudDataAccessAssignments.push({
                                RoleCode: roleCode,
                                RoleName: item.RoleName || item.Rolerf || roleName,
                                RoleDisplayName: roleName,
                                SecurityContext: securityContext,
                                Name: name,
                                UserName: $scope.vm.User.OracleCloudUser.UserName,
                                Active: item.ActiveFlag !== false && item.Active !== false,
                                Id: item.Id || item.UserRoleDataAssignmentId || 0,
                                Action: 'Grant'
                            });
                        }
                    });
                }
            } catch (e) {
                // Continue to next role if one fails
            }
        }
    };

    //If $scope variable doesnt exist in child it looks in parent

    $scope.addRoleToList = function (role) {
        $scope.vm.ListOfAvailableOracleCloudRoles.forEach(function (row, i) {
            if (row.RoleID === role.RoleID) {
                $scope.vm.ListOfAvailableOracleCloudRoles.splice(i, 1);
                $scope.vm.ListOfStoredOracleCloudRoles.push({ Role: row });
                $scope.vm.ListOfSelectedOracleCloudRoles.push(role);
            }
        });
        $scope.vm.IsRisksReviewed = null;
    };

    $scope.deleteSelectedRole = function (role) {

        $scope.vm.ListOfSelectedOracleCloudRoles.forEach(function (row, i) {
            if (row.RoleID === role.RoleID) {
                $scope.vm.ListOfSelectedOracleCloudRoles.splice(i, 1);
                if (role.IsAssignable) {
                    $scope.vm.ListOfAvailableOracleCloudRoles.push(role);
                }
            }
        });
        $scope.vm.ListOfStoredOracleCloudRoles.forEach(function (row, j) {
            if (row.RoleID === role.RoleID) {
                $scope.vm.ListOfStoredOracleCloudRoles.splice(j, 1);
            }
        });

        $scope.vm.IsRisksReviewed = null;
    };

    $scope.setSelectedRoleTemplates = function (selectedRoleTemplates) {
        $scope.vm.selectedRoleTemplates = selectedRoleTemplates;
    };

}